import { ALARM_GROUP_SERVICE_NAME, AlarmGroupServiceProvider } from './alarm-group.service'
import { ALARM_GROUP_OPERATORS_SERVICE_NAME, AlarmGroupOperatorServiceProvider } from './alarm-group.operator.service'

export const ALARM_GROUP_SERVICES_MODULE_NAME = 'simax.services.alarm-group'

const alarmGroupServicesModule = angular.module(ALARM_GROUP_SERVICES_MODULE_NAME, [])

alarmGroupServicesModule.provider(ALARM_GROUP_SERVICE_NAME, AlarmGroupServiceProvider)
alarmGroupServicesModule.provider(ALARM_GROUP_OPERATORS_SERVICE_NAME, AlarmGroupOperatorServiceProvider)
